import AGREGAR_CATALOGO_INFRAESTRUCTURA_TIPO from '@/graphql/mutations/administracion/catalogos/infraestructuratipos/agregarCatalogoInfraestructuraTipo.gql';
import ACTUALIZAR_CATALOGO_INFRAESTRUCTURA_TIPO from '@/graphql/mutations/administracion/catalogos/infraestructuratipos/actualizarCatalogoInfraestructuraTipo.gql';
import REMOVER_CATALOGO_INFRAESTRUCTURA_TIPO from '@/graphql/mutations/administracion/catalogos/infraestructuratipos/removerCatalogoInfraestructuraTipo.gql';
import CATALOGO_INFRAESTRUCTURA_TIPOS from '@/graphql/querys/administracion/catalogos/infraestructurastipos/catalogoInfraestructuraTipos.gql';

export default {
  methods: {
    // Agregar Tipo Infraesatructura
    async mixAgregarTipoInfraestructura() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CATALOGO_INFRAESTRUCTURA_TIPO,
          variables: {
            tipoInfraestructura: this.tipoInfraestructura,
          },
          update: (store, { data: { agregarCatalogoInfraestructuraTipo } }) => {
            const query = {
              query: CATALOGO_INFRAESTRUCTURA_TIPOS,
            };
            const { catalogoInfraestructuraTipos } = store.readQuery(query);
            const catalogoInfraestructuraTiposCopia = catalogoInfraestructuraTipos.slice();
            catalogoInfraestructuraTiposCopia.push(agregarCatalogoInfraestructuraTipo);
            store.writeQuery({
              ...query,
              data: {
                catalogoInfraestructuraTipos: catalogoInfraestructuraTiposCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Editar Tipo Infraesatructura
    async mixActualizarTipoInfraestructura() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CATALOGO_INFRAESTRUCTURA_TIPO,
          variables: {
            id: this.tipoInfraestructuraEditar.id,
            tipoInfraestructura: this.tipoInfraestructura,
          },
          update: (store, { data: { actualizarCatalogoInfraestructuraTipo } }) => {
            const query = {
              query: CATALOGO_INFRAESTRUCTURA_TIPOS,
            };
            const data = store.readQuery(query);
            const { catalogoInfraestructuraTipos } = data;
            const index = catalogoInfraestructuraTipos
              .findIndex((catalogoInfraestructuraTipo) => catalogoInfraestructuraTipo.id
              === actualizarCatalogoInfraestructuraTipo.id);
            if (index !== -1) {
              catalogoInfraestructuraTipos.splice(index, 1, actualizarCatalogoInfraestructuraTipo);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar Tipo Infraesatructura
    async mixEliminarTipoInfraestructura() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CATALOGO_INFRAESTRUCTURA_TIPO,
        variables: {
          id: this.tipoInfraestructuraEliminar.id,
        },
        update: (store) => {
          const query = {
            query: CATALOGO_INFRAESTRUCTURA_TIPOS,
          };
          const data = store.readQuery(query);
          const { catalogoInfraestructuraTipos } = data;
          const index = catalogoInfraestructuraTipos
            .findIndex((catalogoInfraestructuraTipo) => catalogoInfraestructuraTipo.id
            === this.tipoInfraestructuraEliminar.id);
          if (index !== -1) {
            catalogoInfraestructuraTipos.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
